import React from "react";
import { TextField, TextArea, CheckboxField } from "../../common/FormFields/index.js";
import ShortDescriptionEditor from "../../common/RichTextEditor/ShortDescriptionEditor";

const AddEditForm = ({
  mode = "add",
  formData,
  setFormData,
  versionIdRef = "",
  onFieldChange = null, // Callback when any field changes
  onShortDescriptionDirtyChange = null, // Undo-based dirty signal from Lexical editor
}) => {
  const handleInputChange = (field, value) => {
    // Only update if the value has actually changed
    if (formData[field] === value) return;
    
    const newFormData = {
      ...formData,
      [field]: value,
    };
    setFormData(newFormData);
    if (onFieldChange) onFieldChange(newFormData);
  };

  return (
    <form className="section-form" style={{ padding: mode === "edit" ? "20px" : "0" }}>
      {/* <CheckboxField
        checked={formData.isHide}
        onChange={(e) => handleInputChange("isHide", e.target.checked)}
        description={`Hide Section Heading and Short Description from ${mode === "add" ? "Document" : "Procedure"}`}
      /> */}
      
      <TextField
        label="Version ID (Read Only)"
        value={mode === "edit" ? versionIdRef : ""}
        readOnly
        width="30%"
        className="form-field-margin-top"
        inputStyle={{ 
          color: mode === "edit" ? "#999999" : "inherit"
        }}
      />

      <TextField
        label="Section Name"
        value={formData.sectionName}
        onChange={(e) => handleInputChange("sectionName", e.target.value)}
        placeholder="Enter Section Name"
        required
        width="30%"
        className="form-field-margin-top"
      />

      <div className="form-field-margin-top" style={{marginLeft:"10px"}}>
        <label className="block font-semibold" style={{ marginBottom: "8px" }}>
          Short Description
        </label>
        <ShortDescriptionEditor
          value={formData.shortDescription}
          onChange={(htmlContent) => handleInputChange("shortDescription", htmlContent)}
          onDirtyChange={onShortDescriptionDirtyChange}
          placeholder="Enter short description"
          minHeight="100px"
        />
      </div>
    </form>
  );
};

export default AddEditForm;

